module.exports = __webpack_public_path__ + "media/images/hotelshome-276d7ad3.jpeg";